import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import diff from 'object-diff';
import GroupDetail from './GroupDetail';
import GroupDetailForm from './GroupDetailForm';

class GroupDetailModal extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleSubmit(values) {
    const changedValues = diff(this.props.group, values);
    console.log('handle submit: ', changedValues);
    this.props.editGroup(this.props.group.id, changedValues);
    this.props.onClose();
  }
  render() {
    let detail;
    if (this.props.editing) {
      detail = (
        <GroupDetailForm
          group={this.props.group}
          initialValues={this.props.group}
          onSubmit={this.handleSubmit}
        />
      );
    } else {
      detail = <GroupDetail group={this.props.group} />;
    }
    return (
      <div>
        <Modal bsSize="large" show={this.props.show} onHide={this.props.onClose}>
          <Modal.Header closeButton>
            <Modal.Title>Group: {this.props.group.name}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{detail}</Modal.Body>
          <Modal.Footer />
        </Modal>
      </div>
    );
  }
}

GroupDetailModal.propTypes = {
  group: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  editing: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  editGroup: PropTypes.func.isRequired,
};

export default GroupDetailModal;



// WEBPACK FOOTER //
// src/routes/tours/components/GroupDetailModal.js